import type { DriveStep } from 'driver.js';

export const doctorDashboardSteps: DriveStep[] = [
  {
    element: '[data-tour="doctor-dashboard-hero-banner"]',
    popover: {
      title: 'Share Your Intake Form',
      description:
        'Your personalized intake link. Share it with attorneys so they can submit pre-screening requests directly to you.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-dashboard-stats"]',
    popover: {
      title: 'Your Practice at a Glance',
      description:
        'Total revenue, active cases, pending invoices, and completion rate — updated in real time.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-dashboard-encryption"]',
    popover: {
      title: 'End-to-End Encryption',
      description:
        'Lock or unlock encryption to protect sensitive case data. Set up your passphrase in Settings.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-dashboard-referral"]',
    popover: {
      title: 'Refer and Earn',
      description:
        'Copy your referral link to invite colleagues. Earn 25% of platform fees for 12 months per referral.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-dashboard-notifications"]',
    popover: {
      title: 'Notifications',
      description:
        'New intake requests and payment alerts appear here. Click any to navigate to the relevant item.',
      side: 'left',
      align: 'center',
    },
  },
];
